import { atom, type ReadableAtom } from 'nanostores';
import { chatStore } from './chat';
import { projectStore } from './project';

const _descriptionStore = atom<string | undefined>();

export const descriptionStore = _descriptionStore as ReadableAtom<string | undefined>;

export function setDescription(description: string | undefined) {
  _descriptionStore.set(description);

  const projectId = projectStore.getProjectId();

  if (projectId) {
    const chatList = chatStore.chatList.get();
    const chatIndex = chatList.findIndex((c) => c.projectId === projectId);

    if (chatIndex !== -1) {
      const chatItem = {
        ...chatList[chatIndex],
        description,
      };

      chatStore.chatList.set([...chatList.slice(0, chatIndex), chatItem, ...chatList.slice(chatIndex + 1)]);
    }
  }
}

export function getDescription() {
  return descriptionStore.get();
}
